import React from 'react';

class Enterprisesign extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type: 'input',
            type1: 'input',
            score: 'null',
            score1: 'null'
        }
        this.showHide = this.showHide.bind(this);
        this.showHide1 = this.showHide1.bind(this);
        this.passwordStrength = this.passwordStrength.bind(this);
        this.passwordStrength1 = this.passwordStrength1.bind(this);
    }

    showHide(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            type: this.state.type === 'input' ? 'password' : 'input'
        })
    }

    showHide1(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            type: this.state.type1 === 'input' ? 'password' : 'input'
        })
    }
    passwordStrength(e) {
        if (e.target.value === '') {
            this.setState({
                score: 'null'
            })
        }
        else {
            var pw = (e.target.value);
            this.setState({
                score: pw.score
            });
        }

    }
    passwordStrength1(e) {
        if (e.target.value === '') {
            this.setState({
                score1: 'null'
            })
        }
        else {
            var pw = (e.target.value);
            this.setState({
                score1: pw.score
            });
        }

    }
    render() {
        return (
            <div id="page-container" class="fade page-sidebar-fixed page-header-fixed">

                <div className="login login-with-news-feed">

                    <div className="news-feed">
                        <div className="news-image" style={{ backgroundImage: 'url(../assets/img/login-bg/login-bg-11.jpg)' }} />

                    </div>

                    <div className="right-content">

                        <div className="login-header d-flex justify-content-center align-items-center m-b-40">

                            <img src="../assets/img/logo/STT-Logo.png" style={{ height: '45px' }}></img>
                            <span className="brand-Name">STT</span>


                        </div>

                        <div className="login-content">
                            
                            <form action="index.html" method="GET" className="margin-bottom-0 login-container shadow-add">

                                <div className="form-group  m-b-15">
                                    <label className="login-input">Email  </label>

                                    <input className="form-control form-control-lg" type="email" placeholder="Enter Your Email" required />

                                </div>
                                <div className="form-group m-b-15">
                                    <label className="login-input">Password</label>

                                    <div class="input-group">

                                        <input type={this.state.type} className="form-control password__input form-control-lg" onChange={this.passwordStrength} placeholder="Enter Your Password" required />
                                        <span className="input-group-text password__show " onClick={this.showHide}>{this.state.type === 'input' ? <i className="fas fa-eye-size fa-fw  fa-eye"></i> : <i className="fas fa-eye-size fa-fw fa-eye-slash"></i>}</span>
                                    </div>
                                </div>
                                <div className="form-group m-b-15">
                                    <label className="login-input">Repeat Password</label>

                                    <div class="input-group">

                                        <input type={this.state.type1} className="form-control password__input form-control-lg " onChange={this.passwordStrength1} placeholder="Enter Your Password" required />
                                        <span className="input-group-text password__show " onClick={this.showHide1}>{this.state.type1 === 'input' ? <i className="fas fa-eye-size fa-fw  fa-eye"></i> : <i className="fas fa-eye-size fa-fw fa-eye-slash"></i>}</span>
                                       
                                    </div>
                                </div>
                                <div className="form-group  m-b-15">
                                    <label className="login-input">Company name (optional) </label>

                                    <input className="form-control form-control-lg" type="text" placeholder=""  />

                                </div>
                                <div className="login-buttons">
                                    <button type="submit" className="btn btn-primary btn-block  sign-button">Sign up</button>
                                </div>


                            </form>
                        </div>

                    </div>

                </div>

            </div>
        )
    }
}

export default Enterprisesign;